import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { purifier, scrollTo, offset } from '../../../utils/dom';
import { cleanInternalLinks } from '../../../utils/string';

const Button = ({ content, attrs = {}, setup, isManyButtons = 1 }) => {
	const variantClasses = ['button__content'];
	let style = {};

	if (isManyButtons > 1) variantClasses.push('button__multiple');
	if (attrs.outline) variantClasses.push('button__outline');
	if (attrs.fullWidth) variantClasses.push('button__fullWidth');
	if (attrs.fontSize) variantClasses.push(`button__${attrs.fontSize}`);
	if (attrs.className) variantClasses.push(`button_${attrs.className}`);
	if (attrs.textColor) style = { color: attrs.textColor, borderColor: attrs.textColor };

	if (!content.rawText) return null;

	const clickEventHandler = (e) => {
		const link = e.currentTarget.getAttribute('href');
		if (/^#/.test(link) && document.getElementById(link.slice(1))) {
			e.preventDefault();
			const linkOffset = offset(document.getElementById(link.slice(1)));
			scrollTo(300, linkOffset.top - 60);
		}
	};

	return (
		<ButtonElement type="link" location={cleanInternalLinks(content.attrs.href, setup)} variantClasses={variantClasses} clickEventHandler={clickEventHandler} style={style}>
			<span dangerouslySetInnerHTML={{ __html: purifier(content.rawText, {}, setup) }} />
		</ButtonElement>
	);
};

export default hot(module)(Button);
